import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import credentials from "../../../config/credentials";
import {Alert, Button, Card, CardBody} from "reactstrap";
import LinearProgress from "@mui/material/LinearProgress";

export default function CheckoutForm(props) {
    // 1️⃣ Setup state to track client secret, errors and checkout status
    const [succeeded, setSucceeded] = useState(false);
    const [error, setError] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [clientSecret, setClientSecret] = useState("");
    const [notification, setNotification] = useState("")
    const { order, onConfirm } = props;
    // 2️⃣ Store reference to Stripe
    const stripe = useStripe();
    const elements = useElements();
    useEffect(() => {
        // 3️⃣ Create PaymentIntent and fetch client secret as soon as the page loads
        const invoice_id = order[0]["invoice_id"]
        const paymentIntentURL = `${credentials.API_URL}/stripe-payment-intent/`
        window.fetch(paymentIntentURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ invoice_id: invoice_id }),
        }).then((res) => {
            return res.json();
        }).then((data) => {
            setClientSecret(data.clientSecret);
        });
    }, []);
    const handleChange = async (event) => {
        // 4️⃣ Listen for changes in the CardElement and display any errors as the customer types their card details
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    };
    const handleSubmit = async (ev) => {

        ev.preventDefault();
        setProcessing(true);

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }
        // Get a reference to a mounted CardElement. Elements knows how
        // to find your CardElement because there can only ever be one of
        // each type of element.
        const cardElement = elements.getElement(CardElement);

        // 5. Confirm Card Payment.
        const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement),
            },
        });
        if (payload.error) {
            setError(true);
            setNotification(`Payment failed. ${payload.error.message}`)
            setProcessing(false);
        } else {
            setError(false);
            setNotification("Card Payment Successful")
            onConfirm()
            // setProcessing(false);
        }
    };
    // Construct UI.
    return (
        <div>
            { processing ?
                <LinearProgress />
                :
                null
            }
            <Card className="bg-light" style={{padding: "0px 8px 8px 8px", textAlign: "center"}}>
                <CardBody>
                    <div className="col-lg-6 col-sm-12 offset-lg-3">
                        <div className="basket-page-information checkout-item-title"
                             style={{padding: "16px 0px 24px 0px"}}
                        >
                            Card Payment
                        </div>
                        {notification &&
                        <div style={{padding: "16px 0px 8px 0px"}}>
                            <Alert color={error ? "danger" : "success"}>
                                {notification}
                            </Alert>
                        </div>
                        }
                        <form id="payment-form" onSubmit={handleSubmit}>
                            <CardElement
                                id="card-element"
                                // Specify styles here
                                options={{
                                    style: {
                                        base: {
                                            fontSize: '16px',
                                            color: '#424770',
                                            '::placeholder': {
                                                color: '#aab7c4',
                                            },
                                            border: '2px solid black'
                                        },
                                        invalid: {
                                            color: '#9e2146',
                                        },
                                    },
                                }}
                                onChange={handleChange}
                            />
                            <div style={{padding: "32px 0px 16px 0px"}}>
                                <Button
                                    size={"sm"}
                                    disabled={processing || disabled || succeeded}
                                    className="delete-basket-button"
                                    id="submit">
                                    Pay
                                </Button>
                            </div>
                        </form>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
}
